import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';

import { devices } from 'styles';

export const ImageWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  display: block;
  border-radius: 8px;

  img {
    width: 100%;
    height: 300px;
    display: block;
    border-radius: 16px;
    object-fit: cover;

    @media (${devices.sm}) {
      width: 100%;
      height: 300px;
    }

    @media (${devices.md}) {
      width: 560px;
      height: 640px;
    }
  }

  @media (${devices.sm}) {
    margin-top: 0;
  }
`;

export const MosaicWrapper = styled(Box)`
  display: flex;
  width: 100%;
  height: 420px;
  gap: 12px;

  @media (${devices.sm}) {
    height: 480px;
    gap: 16px;
  }

  @media (${devices.md}) {
    width: 560px;
    height: 640px;
  }
`;

export const MosaicColumn = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-width: 0;

  @media (${devices.sm}) {
    gap: 16px;
  }
`;

export const MosaicCell = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: 'small' | 'big' }>`
  flex: ${({ variant }) => (variant === 'big' ? 5 : 3)};
  overflow: hidden;
  border-radius: 16px;
  min-height: 0;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`;
